import script from "./NovelStudio.vue?vue&type=script&setup=true&lang=js"
export * from "./NovelStudio.vue?vue&type=script&setup=true&lang=js"

import "./NovelStudio.vue?vue&type=style&index=0&id=2201ff31&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2201ff31"]])

export default __exports__